import './index.less';
//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, hook } = checkApp.core;//eslint-disable-line

const data = window._notify || [{
  text: '测试消息一',
  link: '//aliyun.com',
  target: ''
}, {
  text: '测试消息二',
  link: '//aliyun.com',
  target: ''
}];

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('notify', [], 99999)
export default class NotifyFeature extends Feature {

  renderList(list) {
    return list.map((item, index) => (
      <a key={index} className="item" href={item.link || item.value}
        target={item.target || '_blank'}>{index + 1}. {item.text}</a>
    ));
  }

  @hook('main.notify')
  getNotify() {
    if (!data || data.length < 1) return;
    return <div className="notify">
      <i className="glyphicon glyphicon-volume-up"></i>
      {this.renderList(data)}
    </div>;
  }

}


// WEBPACK FOOTER //
// ./src/notify/index.js